import { AdblockDetector } from 'adblock-detector';
import { filter, first } from "rxjs";


export interface CustomPurposesConsents {
  [key: number]: {
    id: number,
    c: boolean;
    li: boolean;
  }
}

export function getAdBlockDetector() {
  if (!window.Rai) {
    window.Rai = {} as Rai;
  }

  if (!window.Rai._adBlockInstance) {
    window.Rai._adBlockInstance = new AdblockDetector();
  }

  return window.Rai._adBlockInstance;
}

export async function getGDPRManager() {
  if (window.Rai?.PolicyManager) {
    return window.Rai.PolicyManager;
  }

  return new Promise<PolicyManager>(resolve => {
    window.Rai = new Proxy(window.Rai ?? ({} as Rai), {
      set(target, prop, val) {
        const setted = Reflect.set(target, prop, val);
        if (prop === 'PolicyManager') {
          setTimeout(() => {
            resolve(window.Rai.PolicyManager);
          }, 0);
        }

        return setted;
      },
    });
  });
}

export async function getPrivacyConsent() {
  const GDPRManager = await getGDPRManager();
  return new Promise(resolve => {
      GDPRManager.events$.subscribe(event => {
      if (event.type === GDPRManager.events['POLICY_MANAGER_DEFINED_EVENT']) {
          const _manager = window.Rai.PolicyManager;
          resolve(_manager.hasOptIn());
      }
      });
  });
}

async function waitForCmpLoaded(): Promise<void> {
  const GDPRManager = await getGDPRManager();

  return new Promise(resolve => {
    GDPRManager.eventsCmpLoaded$
      .pipe(
        filter(Boolean),
        first(event => event.type === GDPRManager.events["CMP_LOADED_EVENT"])
      )
      .subscribe(() => resolve());
  });
}

export async function getCmpLoadedEvent(): Promise<PolicyManager> {
  await waitForCmpLoaded();
  return window.Rai.PolicyManager;
}

export async function getCustomPurposesConsents(): Promise<CustomPurposesConsents> {
  await waitForCmpLoaded();
  return window.Rai.PolicyManager?.getCustomPurposesConsents?.() || {};
}
